import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { GridServerResponse } from './grids.types'

export class GridsProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/gridstate`
  }

  public get(form: string, object?: string): Promise<HttpServiceResponse<GridServerResponse>> {
    const queryString = qs.stringify({
      FormName: form,
      ObjectName: object,
    })

    return this.http.post(`${this.url}_view_api.php?${queryString}`)
  }

  public save(form: string, object: string, gridStates: string): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}_save_api.php`, {
      FormName: form,
      ObjectName: object,
      fieldstates: gridStates,
    })
  }
}
